<aside class="sidebar shadow-sm">
  <nav class="sidebar-menu pt-3 pb-3">
    <span>
      <a class="toggleColor nav-link" [ngClass]="isCollapsed?'menuToggleIn':'menuToggleOut'" (click)="toggleSidebarPin()"><i class="fa fa-bars" tooltip="{{'Toggle' | translate}}" placement="bottom"></i></a>
    </span>

    <ul class="menu-items">
      <li>
        <a routerLink="/Home" routerLinkActive="active">
          <i class="fa fa-home" tooltip="{{'Home' | translate}}" placement="bottom"></i>
          <span>{{"Home" | translate}}</span>
        </a>
      </li>
      <li *ngIf="this.userRole === 'admin'">
        <a href="#masterSubmenu" data-toggle="collapse" aria-expanded="false" class="toggles collapsed">
          <i class="fa fa-university" tooltip="{{'Master' | translate}}" placement="bottom"></i>
          <span>{{'Master' | translate}}</span></a>
        <div id="masterSubmenu">
          <ul class="list-unstyled">
            <li>
              <a routerLink="/OfferPeriod" routerLinkActive="active">
                <i class="fa fa-hourglass-end" style="margin-left: 2rem;" tooltip="{{'Offer-Period' | translate}}"
                  placement="bottom"></i>
                <span>{{"Offer-Period" | translate}}</span>
              </a>
            </li>
            <li>
              <a routerLink="/InterestPeriod" routerLinkActive="active">
                <i class="fa fa-percent" style="margin-left: 2rem;" tooltip="{{'Interest-Period' | translate}}"
                  placement="bottom"></i>
                <span>{{"Interest-Period" | translate}}</span>
              </a>
            </li>
          </ul>
        </div>
      </li>

      <li *ngIf="this.userRole === 'admin'">
        <a href="#importSubmenu" data-toggle="collapse" aria-expanded="false" class="toggles collapsed">
          <i class="fa fa-upload" tooltip="{{'Import-Data' | translate}}" placement="bottom"></i>
          <span>{{'Import-Data' | translate}}</span></a>
        <div class="collapsed" id="importSubmenu">
          <ul class="list-unstyled">
            <li>
              <a routerLink="/Import/Personal" routerLinkActive="active">
                <i class="fas fa-users" style="margin-left: 2rem;" tooltip="{{'Personal-Info' | translate}}"
                  placement="bottom"></i>
                <span>{{'Personal-Info' | translate}}</span>
              </a>
            </li>
            <li>
              <a routerLink="/Import/Emission" routerLinkActive="active">
                <i class="fas fa-balance-scale" style="margin-left: 2rem;" tooltip="{{'Emission' | translate}}"
                  placement="bottom"></i>
                <span>{{"Emission" | translate}}</span>
              </a>
            </li>
            <li>
              <a routerLink="/Import/Interest" routerLinkActive="active">
                <i class="fas fa-money-bill-wave" style="margin-left: 2rem;max-width: fit-content;"
                  tooltip="{{'Interest-payments' | translate}}" placement="bottom"></i>
                <span>{{"Interest-payments" | translate}}</span>
              </a>
            </li>
          </ul>
        </div>
      </li>

      <li *ngIf="this.userRole === 'admin'">
        <a routerLink="/Reminder" routerLinkActive="active">
          <i class="fas fa-business-time" tooltip="{{'Reminder' | translate}}" placement="bottom"></i>
          <span>{{"Reminder" | translate}}</span>
        </a>
      </li>

      <li *ngIf="this.userRole === 'admin'">
        <a routerLink="/Enquiry" routerLinkActive="active">
          <i class="far fa-comment-dots" tooltip="{{'Enquiry' | translate}}" placement="bottom"></i>
          <span>{{"Enquiry" | translate}}</span>
        </a>
      </li>

      <li *ngIf="this.userRole === 'admin'">
        <a routerLink="/Disclaimer" routerLinkActive="active">
          <i class="fas fa-tags" tooltip="{{'Disclaimer' | translate}}" placement="bottom"></i>
          <span>{{'Disclaimer' | translate}}</span>
        </a>
      </li>
      <li>
        <a href="https://www.euroland.com/" target="_blank">
          <i class="fa fa-info-circle" tooltip="{{'About-euroland-IR' | translate}}" placement="bottom"></i>
          <span>{{"About-euroland-IR" | translate}}</span>
        </a>
      </li>
      <li>
        <a>
          <i class="fa fa-newspaper" tooltip="{{'Latest-news' | translate}}" placement="bottom"></i>
          <span>{{"Latest-news" | translate}}</span>
        </a>
      </li>
      <li>
        <a>
          <i class="fa fa-question-circle" tooltip="FAQ" placement="bottom"></i>
          <span>FAQ's</span>
        </a>
      </li>
    </ul>
  </nav>
</aside>
